import debounce from 'lodash.debounce'

export function bufferFunction<T>(fn: (input: T[]) => unknown, wait: number) {
  let inputs: T[] = []
  const debouncedFn = debounce(async () => {
    const calledInput = inputs
    inputs = inputs.slice(calledInput.length)
    await fn(calledInput)
  }, wait)

  return (input: T) => {
    inputs.push(input)
    debouncedFn()
  }
}
